import { render, staticRenderFns } from "./InspectionDueEmpty.vue?vue&type=template&id=58e6f9b9&"
import script from "./InspectionDueEmpty.vue?vue&type=script&lang=ts&"
export * from "./InspectionDueEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports